const env = (process.env.NODE_ENV === 'production' ? 'prod' : 'dev');

const config = {
  dev: {
    jwtSecret: process.env.JWT_SECRET || 'demo-secret',
    BASE_URL: process.env.BASE_URL || 'http://localhost:8889',
    SOCKET_URL: process.env.SOCKET_URL || 'http://localhost:3578'
  },
  prod: {
    jwtSecret: process.env.JWT_SECRET || 'demo-secret',
    BASE_URL: process.env.BASE_URL || 'http://localhost:8889',
    SOCKET_URL: process.env.SOCKET_URL || 'http://localhost:3578'
  }
};

module.exports = config[env];



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 1